export default __webpack_public_path__ + "static/media/a012-market-1.750b8b77.svg";